import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import store from './store'
import echarts from 'echarts'
import {
  postRequest,
  postKeyValueRequest,
  putRequest,
  deleteRequest,
  getRequest
} from './utils/api'
import {
  projectUtil, Utils
} from './utils/utils'

Vue.prototype.postRequest = postRequest
Vue.prototype.postKeyValueRequest = postKeyValueRequest
Vue.prototype.putRequest = putRequest
Vue.prototype.deleteRequest = deleteRequest
Vue.prototype.getRequest = getRequest

Vue.prototype.projectUtil = projectUtil
Vue.prototype.Utils = Utils

Vue.prototype.$echarts = echarts

var axios = require('axios')
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_ROOT
// 全局注册，之后可在其他组件中通过 this.$axios 发送数据
Vue.prototype.$axios = axios
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // 如果前端没有登录信息则直接拦截，如果有则判断后端是否正常登录（防止构造参数绕过）
  if (to.meta.requireAuth) {
    var goToLogin = function (param) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
    if (store.state.user) {
      getRequest('/authentication').then(resp => {
        if (resp && resp.code === 200 && resp.result === 'authencated') {
          next()
        } else {
          goToLogin()
        }
      })
    } else {
      goToLogin()
    }
  } else {
    next()
  }
})

const Base64 = require('js-base64').Base64
Vue.prototype.$Base64 = Base64

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
